import React, { useState, useEffect } from 'react';
import DashboardTable from '../DashboardTable';
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'


const TerminationReasonsTable = (props) => {
    const [terminationReasons, setTerminationReasons] = useState([]);
    const [terminationReasonsLoading, setTerminationReasonsLoading] = useState(false);
    const [terminationReasonHeaders, setTerminationReasonHeaders] = useState([]);

    useEffect(() => {
        getTerminationReasons(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);

    }, [props.preferencesChanged]);

    const prepareTerminationReasonsData = (data) => {
        let reasons = [];
        let headers = [{
            key: "reasons",
            header: DashboardConstants.Reasons
        }];
        let key;
        if (data) {
            let buckets = data.aggregations.automata_info.buckets;
            for (let i = 0; i < buckets.length; i++) {
                reasons[i] = {
                    id: i,
                    reasons: buckets[i].key
                }
                for (let j = 0; j < buckets[i].time_zone_interval.buckets.length; j++) {
                    key = buckets[i].time_zone_interval.buckets[j]["key_as_string"];
                    if (i === 0) {
                        headers[j + 1] = {
                            key: buckets[i].time_zone_interval.buckets[j].key,
                            header: key.substr(0, key.indexOf(' '))
                        }
                    }
                    reasons[i][buckets[i].time_zone_interval.buckets[j].key] = buckets[i].time_zone_interval.buckets[j]["doc_count"];
                }
            }
            setTerminationReasonHeaders(headers);
        }
        return reasons;
    };

    const getTerminationReasons = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
            let timeZone = moment.tz.guess();
            let bodyJSON
            if (workspace === workspaces.automation_ops) {

                bodyJSON = {
                    "filters": {
                        "time": {
                            "startDateTime": timeFilterSelections.startDateTime,
                            "endDateTime": timeFilterSelections.endDateTime
                        },
                        "franchises": dashboardFilterSelectionsAutomation.franchise,
                        "clients": dashboardFilterSelectionsAutomation.client,
                        "technologies": dashboardFilterSelectionsAutomation.technology,
                        "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                        "geos": dashboardFilterSelectionsAutomation.geo,
                        "assignment_groups": dashboardFilterSelectionsAutomation.assignee,
                        "business_competencies": dashboardFilterSelectionsAutomation.competency,
                        "incident_status": dashboardFilterSelectionsAutomation.status,
                        "automata_priority": dashboardFilterSelectionsAutomation.priority,
                        "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                        "resource": dashboardFilterSelectionsAutomation.resource

                    },
                    "interval": {
                        "calender_Interval": calenderInterval,
                        "time_zone": timeZone
                    },
                    "workspace": workspace
                };
            }
            let formattedData = [];
            setTerminationReasonsLoading(true);
            callPostApi(Constants.GETTERMINATIONREASONS, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    setTerminationReasonsLoading(false);
                    formattedData = prepareTerminationReasonsData(resp);
                    setTerminationReasons(formattedData);
                }).catch((error) => {
                    setTerminationReasonsLoading(false);
                    console.error('Error:', error);
                });
        }
    }

    return (
        <section className="termination-reasons">
            <div className="graph-title carbon-display-Regular-20">
                <div>
                    {DashboardConstants.TopTerminationsReasons}
                </div>
                <div className="download-button">
                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={terminationReasons} headers={terminationReasonHeaders} title={DashboardConstants.TopTerminationsReasons} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                </div>
            </div>
            <div className="reasons-table">
                <DashboardTable size="tall" loading={terminationReasonsLoading} rows={terminationReasons} headers={terminationReasonHeaders}
                    showPagination={false} />
            </div>
        </section>
    );
}

export default TerminationReasonsTable
